import React from "react";

const PlaceType = {
  Chamado: 1,
  Portal: 2,
  Empresa: 3,
  Solicitante: 4,
  All: 5
};

const placeholdersData = [
  // Chamado (Ticket)
  { id: "ticket.id", name: "Id do chamado", type: PlaceType.Chamado },
  { id: "ticket.title", name: "Título", type: PlaceType.Chamado },
  { id: "ticket.description", name: "Descrição", type: PlaceType.Chamado },
  { id: "ticket.due_date", name: "Data de previsão", type: PlaceType.Chamado },
  { id: "ticket.status.name", name: "Status", type: PlaceType.Chamado },
  { id: "ticket.priority.name", name: "Prioridade", type: PlaceType.Chamado },
  { id: "ticket.origin.name", name: "Origem", type: PlaceType.Chamado },
  { id: "ticket.type.name", name: "Tipo", type: PlaceType.Chamado },
  { id: "ticket.team.name", name: "Time", type: PlaceType.Chamado },
  { id: "ticket.category.name", name: "Categoria", type: PlaceType.Chamado },
  { id: "ticket.address.name", name: "Endereço", type: PlaceType.Chamado },
  {
    id: "ticket.organization.name",
    name: "Organização",
    type: PlaceType.Chamado,
  },
  { id: "ticket.hirer.name", name: "Empresa", type: PlaceType.Chamado },
  { id: "ticket.technical.name", name: "Técnico", type: PlaceType.Chamado },
  {
    id: "ticket.technical.email",
    name: "E-mail Técnico",
    type: PlaceType.Chamado,
  },
  { id: "ticket.observer.name", name: "Observador", type: PlaceType.Chamado },
  { id: "ticket.parent.name", name: "Chamado pai", type: PlaceType.Chamado },
  { id: "ticket.url", name: "Url do Ticket", type: PlaceType.Chamado },
  { id: "ticket.tags", name: "Tags", type: PlaceType.Chamado },
  {
    id: "ticket.acc.latest_public_comment",
    name: "Último acompanhamento público",
    type: PlaceType.Chamado,
  },
  {
    id: "ticket.acc.latest_private_comment",
    name: "Último acompanhamento privado",
    type: PlaceType.Chamado,
  },
  { id: "ticket.group.name", name: "Nome do Grupo", type: PlaceType.Chamado },

  // Portal
  { id: "portal.name", name: "Nome do portal", type: PlaceType.Portal },
  { id: "portal.title", name: "Título do portal", type: PlaceType.Portal },

  // Empresa
  { id: "hirer.name", name: "Nome contratante", type: PlaceType.Empresa },
  { id: "hirer.email", name: "E-mail contratante", type: PlaceType.Empresa },
  {
    id: "hirer.document",
    name: "Documento contratante",
    type: PlaceType.Empresa,
  },
  { id: "hirer.website", name: "Website contratante", type: PlaceType.Empresa },
  { id: "hirer.phone", name: "Fone contratante", type: PlaceType.Empresa },
  {
    id: "hirer.responsiblename",
    name: "Nome responsável",
    type: PlaceType.Empresa,
  },
  {
    id: "hirer.responsibleemail",
    name: "Email responsável",
    type: PlaceType.Empresa,
  },
  { id: "hirer.plan", name: "Plano contratado", type: PlaceType.Empresa },
  { id: "hirer.renewaldate", name: "Data renovação", type: PlaceType.Empresa },

  // Solicitante
  {
    id: "ticket.requester.name",
    name: "Nome solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.phone",
    name: "Fone solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.mail",
    name: "E-mail solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.document",
    name: "CPF solicitante",
    type: PlaceType.Solicitante,
  },
  {
    id: "ticket.requester.address",
    name: "Endereço solicitante",
    type: PlaceType.Solicitante,
  },
];

const groups = [
  { id: PlaceType.Chamado, name: "Ticket", icon: "🎫" },
  { id: PlaceType.Portal, name: "Portal", icon: "🌐" },
  { id: PlaceType.Empresa, name: "Empresa", icon: "🏢" },
  { id: PlaceType.Solicitante, name: "Contato", icon: "👤" },
];

const styles = {
  addButton: {
    width: "40px",
    height: "40px",
    backgroundColor: "#4caf50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    transition: "background-color 0.2s",
  },
  addButtonHover: {
    backgroundColor: "#388e3c",
  },
  popupContainer: {
    position: "fixed",
    zIndex: 1000,
    filter: "drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15))",
  },
  popup: {
    backgroundColor: "white",
    width: "380px",
    maxHeight: "480px",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #e0e0e0",
  },
  popupArrow: {
    position: "absolute",
    width: 0,
    height: 0,
    borderStyle: "solid",
  },
  popupHeader: {
    padding: "12px 16px",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  popupTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#666",
    padding: "2px",
    borderRadius: "4px",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s",
  },
  closeButtonHover: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  searchBox: {
    padding: "12px 16px",
    borderBottom: "1px solid #e0e0e0",
  },
  searchInputWrapper: {
    position: "relative",
  },
  searchInput: {
    width: "100%",
    padding: "8px 12px 8px 36px",
    fontSize: "14px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    outline: "none",
    transition: "border-color 0.2s",
  },
  searchInputFocused: {
    borderColor: "#1976d2",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#666",
    pointerEvents: "none",
  },
  placeholderList: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
  },
  groupHeader: {
    padding: "10px 16px",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    transition: "background-color 0.2s",
  },
  groupHeaderHover: {
    backgroundColor: "#e8e8e8",
  },
  groupTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  expandIcon: {
    fontSize: "16px",
    color: "#666",
    transition: "transform 0.2s",
  },
  placeholderItem: {
    padding: "10px 16px 10px 36px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    transition: "background-color 0.2s",
  },
  placeholderItemHover: {
    backgroundColor: "rgba(25, 118, 210, 0.08)",
  },
  placeholderName: {
    fontSize: "13px",
    color: "#333",
    marginBottom: "2px",
  },
  placeholderCode: {
    fontSize: "12px",
    fontFamily: "monospace",
    backgroundColor: "rgba(25, 118, 210, 0.1)",
    color: "#1976d2",
    padding: "2px 6px",
    borderRadius: "3px",
    display: "inline-block",
  },
};

export default function AddCommonPlaceholder({
  value = "",
  onChange,
  textAreaRef = null,
  types = [PlaceType.All]
}) {
  const [popupOpen, setPopupOpen] = React.useState(false);

  const [searchTerm, setSearchTerm] = React.useState("");

  const [expandedGroups, setExpandedGroups] = React.useState({
    [PlaceType.Chamado]: true,
    [PlaceType.Portal]: true,
    [PlaceType.Empresa]: true,
    [PlaceType.Solicitante]: true,
  });
  const [popupPosition, setPopupPosition] = React.useState({ top: 0, left: 0 });
  const [cursorPosition, setCursorPosition] = React.useState(0);
  const [isAddButtonHovered, setIsAddButtonHovered] = React.useState(false);
  const [isCloseButtonHovered, setIsCloseButtonHovered] = React.useState(false);
  const [hoveredGroup, setHoveredGroup] = React.useState(null);
  const [hoveredItem, setHoveredItem] = React.useState(null);
  const [isSearchFocused, setIsSearchFocused] = React.useState(false);

  const popupRef = React.useRef(null);
  const buttonRef = React.useRef(null);

  const filteredPlaceholders = React.useMemo(() => {
    if (!searchTerm) return filterByTypes(placeholdersData, types);

    const lowerSearch = searchTerm.toLowerCase();
    return filterByTypes(placeholdersData, types).filter(
      (p) =>
        p.name.toLowerCase().includes(lowerSearch) ||
        p.id.toLowerCase().includes(lowerSearch)
    );
  }, [searchTerm]);

  const groupedPlaceholders = React.useMemo(() => {
    const grouped = {};
    groups.forEach((group) => {
      grouped[group.id] = filteredPlaceholders.filter(
        (p) => p.type === group.id
      );
    });
    return grouped;
  }, [filteredPlaceholders]);

  function filterByTypes(list, activeTypes) {
    if (activeTypes.includes(PlaceType.All)) {
      return list;
    }

    return list.filter(item => activeTypes.includes(item.type));
  }

  const handleTogglePopup = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!popupOpen && textAreaRef && textAreaRef.current) {
      setCursorPosition(textAreaRef.current.selectionStart || 0);
    }

    setPopupOpen(!popupOpen);

    if (!popupOpen) {
      setSearchTerm("");
    }
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSearchTerm("");
  };

  const handleToggleGroup = (groupId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  const handleSelectPlaceholder = (placeholder) => {
    const placeholderText = `{{${placeholder.id}}}`;

    const _value = value || "";

    const newValue =
      _value.slice(0, cursorPosition) +
      _value.slice(cursorPosition) +
      placeholderText;

    onChange(newValue);
    handleClosePopup();

    setTimeout(() => {
      if (textAreaRef && textAreaRef.current) {
        textAreaRef.current.focus();
        const newCursorPos = cursorPosition + placeholderText.length;
        textAreaRef.current.setSelectionRange(newCursorPos, newCursorPos);
      }
    }, 100);
  };

  const updatePosition = () => {
    if (popupOpen && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const popupWidth = 380;
      const popupHeight = 480;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;

      // Calcular posição vertical
      let top = buttonRect.bottom + 8;
      let showArrowTop = true;

      // Se não houver espaço suficiente abaixo, mostrar acima
      if (top + popupHeight > windowHeight - 20) {
        top = buttonRect.top - popupHeight - 8;
        showArrowTop = false;
      }

      // Calcular posição horizontal
      let left = buttonRect.left;

      // Ajustar se o popup sair da tela pela direita
      if (left + popupWidth > windowWidth - 20) {
        left = buttonRect.right - popupWidth;
      }

      // Garantir que não saia da tela pela esquerda
      if (left < 20) {
        left = 20;
      }

      setPopupPosition({
        top: top,
        left: left,
        showArrowTop,
        arrowLeft: buttonRect.left + buttonRect.width / 2 - left - 8,
      });
    }
  };

  React.useEffect(() => {
    if (popupOpen) {
      updatePosition();
      window.addEventListener("scroll", updatePosition);
      window.addEventListener("resize", updatePosition);
    }
    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, [popupOpen]);


  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setPopupOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [popupOpen]);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={handleTogglePopup}
        style={{
          ...styles.addButton,
          ...(isAddButtonHovered ? styles.addButtonHover : {}),
        }}
        onMouseEnter={() => setIsAddButtonHovered(true)}
        onMouseLeave={() => setIsAddButtonHovered(false)}
        type="button"
      >
        +
      </button>

      {popupOpen && (
        <div
          ref={popupRef}
          style={{
            ...styles.popupContainer,
            position: "fixed",
            top: `${popupPosition.top}px`,
            left: `${popupPosition.left}px`,
          }}
        >
          <div
            style={{
              ...styles.popupArrow,
              ...(popupPosition.showArrowTop
                ? {
                  top: "-8px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "0 8px 8px 8px",
                  borderColor: "transparent transparent #e0e0e0 transparent",
                }
                : {
                  bottom: "-8px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "8px 8px 0 8px",
                  borderColor: "#e0e0e0 transparent transparent transparent",
                }),
            }}
          />

          <div
            style={{
              ...styles.popupArrow,
              ...(popupPosition.showArrowTop
                ? {
                  top: "-7px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "0 8px 8px 8px",
                  borderColor: "transparent transparent #f5f5f5 transparent",
                }
                : {
                  bottom: "-7px",
                  left: `${popupPosition.arrowLeft || 8}px`,
                  borderWidth: "8px 8px 0 8px",
                  borderColor: "white transparent transparent transparent",
                }),
            }}
          />

          <div style={styles.popup}>
            <div style={styles.popupHeader}>
              <h3 style={styles.popupTitle}>
                <span>🏷️</span>
                Variáveis personalizadas
              </h3>
              <button
                onClick={handleClosePopup}
                style={{
                  ...styles.closeButton,
                  ...(isCloseButtonHovered ? styles.closeButtonHover : {}),
                }}
                onMouseEnter={() => setIsCloseButtonHovered(true)}
                onMouseLeave={() => setIsCloseButtonHovered(false)}
              >
                ✕
              </button>
            </div>

            <div style={styles.searchBox}>
              <div style={styles.searchInputWrapper}>
                <span style={styles.searchIcon}>🔍</span>
                <input
                  type="text"
                  placeholder="Procurar uma variáveis personalizadas..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    ...styles.searchInput,
                    ...(isSearchFocused ? styles.searchInputFocused : {}),
                  }}
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={() => setIsSearchFocused(false)}
                  autoFocus
                />
              </div>
            </div>

            <div style={styles.placeholderList}>
              {groups.map((group) => {
                const placeholders = groupedPlaceholders[group.id];
                if (placeholders.length === 0) return null;

                return (
                  <div key={group.id}>
                    <div
                      style={{
                        ...styles.groupHeader,
                        ...(hoveredGroup === group.id
                          ? styles.groupHeaderHover
                          : {}),
                      }}
                      onClick={() => handleToggleGroup(group.id)}
                      onMouseEnter={() => setHoveredGroup(group.id)}
                      onMouseLeave={() => setHoveredGroup(null)}
                    >
                      <div style={styles.groupTitle}>
                        <span>{group.icon}</span>
                        <span>{group.name}</span>
                      </div>
                      <span
                        style={{
                          ...styles.expandIcon,
                          transform: expandedGroups[group.id]
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        ▼
                      </span>
                    </div>

                    {expandedGroups[group.id] && (
                      <div>
                        {placeholders.map((placeholder) => (
                          <div
                            key={placeholder.id}
                            style={{
                              ...styles.placeholderItem,
                              ...(hoveredItem === placeholder.id
                                ? styles.placeholderItemHover
                                : {}),
                            }}
                            onClick={() => handleSelectPlaceholder(placeholder)}
                            onMouseEnter={() => setHoveredItem(placeholder.id)}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            <div style={styles.placeholderName}>
                              {placeholder.name}
                            </div>
                            <span style={styles.placeholderCode}>
                              {`{{${placeholder.id}}}`}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}